import $ from "jquery"
import { trace } from 'rytm-helpers'
import * as THREE from 'three';
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import soundController from './SoundController'
import { getSetup } from "../config";
import WjShape from "../models/WjShape";
// Env
const DEV_MODE = false
// FPS
const FPS = 30
// SETUP object
let setup

class PlaygroundController {
  /**
  * class constructor  
  * @constructor
  **/
  constructor() {
    this.mouseP = {x: 0, y: 0}
    this.objects = []
  }
  /**
   * ### Init Playground ###
   */
  initPlayground() {
    // trace("## init playground")
    if (DEV_MODE) {
      document.querySelector('.editionhome-playground').style.backgroundColor = "#202020";
      document.querySelector('.editionhome-footer').style.display = "none";
    }
    // load vectors from SVG
    setup = getSetup()
    this.shape = new WjShape(setup.svgs[0], setup.svgs[1])
    // prepare Clock for FPS
    this.clock = new THREE.Clock()
    this.clock_delta = 0
    this.clock_interval = 1 / FPS
    this._buildScene()
    this._draw()
    this._animate()
    this._addEventListeners()
    soundController.initSounds()
    setTimeout(() => {
      soundController.play(setup.soundBank)
    }, 200)
  }
  /**
   * ### Destroy Playground ###
   */
  destroyPlayground() {
    // trace("## destroy playground")
    this._removeEventListeners()
    this._destroyScene()
    soundController.stopAllSounds()
    soundController.destroySoundBanks()
  }
  // # add events
  _addEventListeners() {
    $(window).on("resize", $.proxy(this._onWindowResize, this))
    $("body").on("mousemove", $.proxy(this._onMouseMove, this))
    $("body").on("click", $.proxy(this._onMouseClick, this))
    
  }
  // # remove events
  _removeEventListeners() {
    $(window).off("resize", $.proxy(this._onWindowResize, this))
    $("body").off("mousemove", $.proxy(this._onMouseMove, this))
    $("body").off("click", $.proxy(this._onMouseClick, this))
  }
  _updateCanvasSize() {
    clearTimeout(this.updateCanvasSizeTimeout)
    this.updateCanvasSizeTimeout = setTimeout(() => {
      const wrapper = this._getSceneWrapper()
      if (wrapper && this.renderer && this.camera) {
        const d = Math.pow(window.innerWidth, 2) + Math.pow(window.innerHeight, 2)
        // this.camera.position.z = d * .0001;
        this.camera.position.z = 200 + (20000/window.innerWidth) * .4
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize( wrapper.offsetWidth, wrapper.offsetHeight );
      }
    }, 200)
  }
  // # Build ThreeJS scene
  _buildScene() {
    const wrapper = this._getSceneWrapper()
    if (wrapper) {
      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera( setup.camera.CAMERA_FOCAL_LENGTH, window.innerWidth / window.innerHeight, 0.1, 1000 );
      this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
      wrapper.appendChild( this.renderer.domElement )
      this._updateCanvasSize()
    }
  }
  // # Destroy ThreeJS scene
  _destroyScene() {
    const wrapper = this._getSceneWrapper()
    if (wrapper && this.scene && this.renderer) {
      // remove all children from scene
      this._clearScene()
      this.scene = null
      this.renderer.domElement.remove()
      this.renderer = null
      this.camera = null
    }
  }
  _clearScene() {
    if (this.scene) {
      while(this.scene.children.length > 0) { 
        this.scene.remove(this.scene.children[0])
      }
    }
  }
  // Rysuj kształty
  _draw() {
    this._clearScene()
    this.objects = []
    
    let myZ = 0
    let index = 0
    while (myZ < setup.object.OBJECT_MAX_Z) {
      index++
      // tmp
      // myZ += 50
      myZ += Math.round(setup.object.OBJECT_SPACER / index)
      const obj = this._drawShape(myZ) 
      if (obj) {
        obj.userData.index = index
        obj.userData.oryginZ = myZ
        this.objects.push(obj)
      }
    }
  }
  // Rysuj pojedynczy kształt
  _drawShape(z = 0) {
    let lines
    if (this.shape) {
      lines = this.shape.getLines()
      // lines = this.shape.getMesh()
      // lines = this.shape.getThube()
      if (lines) { 
        // lines.rotateZ(-z * .01)
        lines.position.set(0,0,z)
        this.scene.add(lines)
      }
    }
    return lines
  }
  /**
   * #################################
   * ### ANIMACJA klatka po klatce ###
   */
  // # animacja klatka po klatce
  _animate() {
    if (this.renderer && this.scene && this.camera) {
      requestAnimationFrame(this._animate.bind(this))
      // FPS
      this.clock_delta += this.clock.getDelta()
      if (this.clock_delta > this.clock_interval) {
        // Update camera
        this._updateCamera()
        // Update objects
        this._updateObjects()
        // Rebnder
        this.renderer.render(this.scene, this.camera)
        this.clock_delta = this.clock_delta % this.clock_interval
      }
    }
  }
  // ### Objects ###
  // ### Aktualizuj pozycję i pozostałe param obiektów (on enter frame)
  _updateObjects() {
    this.objects.forEach((obj) => {
      // this._shapeObject(obj)
      this._moveObject(obj)
      this._rotateObject(obj)
    })
  }
  // reShape object (change geometry)
  _shapeObject(obj) {
    
    obj.geometry = this.shape.getLineGeometry()
    
    // if (!this.test) {
    //   this.test = true
    //   console.log(obj.geometry)
    // }

    // const positionAttr = obj.geometry.attributes.position
    
    // for (let i = 0; i < positionAttr.count; i++) {
    //   const myX = positionAttr.getX(i)
    //   const myY = positionAttr.getY(i)
    //   const myZ = positionAttr.getZ(i)
    //   myX += Math.random() * 100 - 50;
    //   myY += Math.random() * 100 - 50;
    //   myZ += Math.random() * 100 - 50;
    //   positionAttr.setXYZ(myX, myY, myZ)
    // }
    // positionAttr.needsUpdate = true;
    // obj.geometry.setAttribute('position', positionAttr)
    
  }
  // Rotate OBJECT
  _rotateObject(obj) {
    const dest1 = (setup.object.OBJECT_MAX_Z - obj.position.z) * this.mouseP.x * setup.object.OBJECT_ROTATION_F + this.mouseP.x * .15 + setup.object.OBJECT_ROTATION_SUFIX
    const dist1 = dest1 - obj.rotation.z
    const rotation1 = obj.rotation.z + dist1 * setup.object.OBJECT_ROTATION_SPEED
    obj.rotation.z = rotation1
  }
  // Move Object
  _moveObject(obj) {
    const jump = (setup.object.OBJECT_MAX_Z - obj.position.z) * .01 + .2
    obj.position.z += jump * setup.object.OBJECT_JUMP_F
    if (obj.position.z >= setup.object.OBJECT_MAX_Z) {
      this._shapeObject(obj)
      obj.position.z = setup.object.OBJECT_MIN_Z
    }
  }
  // ### Camera ###
  // Aktualizuj pozycję i focus kamery (on enter frame)
  _updateCamera() {
    const cPos = this._getNewCameraPosition()
    const cFox = this._getNewCameraFocus()
    this.camera.position.x = cPos.x
    this.camera.position.y = cPos.y
    this.camera.lookAt(cFox.x, cFox.y, cFox.z)
    this.camera.updateProjectionMatrix()
  }
  _getNewCameraPosition() {
    let p = {x: 0, y: 0, z: 0}
    if (setup.camera.CAMERA_POS_F != 0) {
      const destX = this.mouseP.x * setup.camera.CAMERA_POS_F
      const destY = -this.mouseP.y * setup.camera.CAMERA_POS_F
      const distX = destX - this.camera.position.x
      const distY = destY - this.camera.position.y
      p.x = this.camera.position.x + distX * setup.camera.CAMERA_POS_SPEED
      p.y = this.camera.position.y + distY * setup.camera.CAMERA_POS_SPEED
    }
    return p
  }
  _getNewCameraFocus() {
    let p = {x: 0, y: 0, z: 0}
    if (setup.camera.CAMERA_FOCUS_F != 0) {
      let prevFocus = this.cameraPrevFocus || p
      const dest1 = -this.mouseP.x * setup.camera.CAMERA_FOCUS_F
      const dest2 = this.mouseP.y * setup.camera.CAMERA_FOCUS_F
      const dist1 = dest1 - prevFocus.x
      const dist2 = dest2 - prevFocus.y
      p.x = prevFocus.x + dist1 * setup.camera.CAMERA_FOCUS_SPEED
      p.y = prevFocus.y + dist2 * setup.camera.CAMERA_FOCUS_SPEED
      this.cameraPrevFocus = p
    }
    return p
  }
  /**
   * #######################
   * ### EVENT LISTENERS ###
   */
  // # on window resize
  _onWindowResize() {
    this._updateCanvasSize()
  }
  // # mouse move
  _onMouseMove(e) {
    this.mouseP = this._getMouseCenterPerc(e)
  }
  _onMouseClick(e) {
    // this.shape = shapesController.getRandomShape()
  }
  /**
   * ###############
   * ### HELPERS ###
   */
  // Zwraca pozycję relatywną myszy względem środka, np. {x: .65, y: -1}
  _getMouseCenterPerc(e) {
    let p = this._getMouseCenterPosition(e)
    return {
      x: Number((p.x / (window.innerWidth * .5)).toFixed(2)),
      y: Number((p.y / (window.innerHeight * .5)).toFixed(2)),
    }
  }
  // Zwraca pozycję myszy względem środka, np. {x: -100, y: 450}
  _getMouseCenterPosition(e) {
    const myX = e.pageX || e.clientX
    const myY = e.pageY || e.clientY
    return {
      x: myX - window.innerWidth * .5,
      y: myY - window.innerHeight * .5
    }
  }
  // # Zwraca element .editionhome-playground
  _getSceneWrapper() {
    return document.querySelector(".editionhome-playground")
  }
  // ile kształtów zawiera kompozycja (zależne od rozdzielczości)
  // _getShapesTotal() {
  //   return Math.round(15 + window.innerWidth / 100)
  // }

}

const playgroundController = new PlaygroundController()
export default playgroundController